import React, { Component } from 'react';

import UserModel from './UserModel';
import RoleModel from './RoleModel';
import CityModel from './CityModel';
import ParkinglocationModel from './ParkinglocationModel';

import { Form, Input, Button, Modal, Transfer } from 'antd';
const FormItem = Form.Item;

class UserForm extends Component {

  state = {
    modalVisible: false,
    transferKeysRoles: [],
    transferTargetKeysRoles: [],
    transferKeysCities: [],
    transferTargetKeysCities: [],
    transferKeysLocations: [],
    transferTargetKeysLocations: [],
  }

  componentWillMount() {
    RoleModel.getAll()
      .then(data => {
        this.setState({
          transferKeysRoles: data
        })
      });
    CityModel.getCityNames()
      .then(data => {
        this.setState({
          transferKeysCities: data
        })
      });
    ParkinglocationModel.getLocationsNames()
      .then(data => {
        this.setState({
          transferKeysLocations: data
        })
      });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
    if (nextProps.initialValues !== this.state.initialValues) {
      if (nextProps.initialValues !== null) {
        this.setState({ transferTargetKeysRoles: nextProps.initialValues.roles, transferTargetKeysCities: nextProps.initialValues.cities, transferTargetKeysLocations: nextProps.initialValues.locations });
      }
      this.setState({
        initialValues: nextProps.initialValues
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        delete values.secondpassword;
        if (!values.cities) values.cities = [];
        if (!values.locations) values.locations = [];
        this.props.onSuccess(this.props.form, values);
        this.props.onModalCancel();
        this.setState({ modalVisible: false });
        // this.setState({
        //   transferTargetKeysRoles: [], transferTargetKeysCities: [], transferTargetKeysLocations: []
        // });
      }
    });
  }

  renderTransferItemRoles(item) {
    const customLabel = (
      <span className="custom-item">
        {item.title} - {item.description}
      </span>
    );

    return {
      label: customLabel, // for displayed item
      value: item.title, // for title and filter matching
    };
  }

  renderTransferItemCities(item) {
    const customLabel = (
      <span className="custom-item">
        {item.code} - {item.name}
      </span>
    );

    return {
      label: customLabel, // for displayed item
      value: item.id, // for title and filter matching
    };
  }

  renderTransferItemLocations(item) {
    const customLabel = (
      <span className="custom-item">
        {item.Code} - {item.Name}
      </span>
    );

    return {
      label: customLabel, // for displayed item
      value: item.id, // for title and filter matching
    };
  }

  handleTransferChangeRoles(targetKeys, direction, moveKeys) {
    this.props.form.setFieldsValue({
      roles: targetKeys
    });
    this.setState({ transferTargetKeysRoles: targetKeys });
  }

  handleTransferChangeCities(targetKeys, direction, moveKeys) {
    this.props.form.setFieldsValue({
      cities: targetKeys
    });
    this.setState({ transferTargetKeysCities: targetKeys });
  }

  handleTransferChangeLocations(targetKeys, direction, moveKeys) {
    this.props.form.setFieldsValue({
      locations: targetKeys
    });
    this.setState({ transferTargetKeysLocations: targetKeys });
  }

  handleValidateUsername(rule, value, cb) {
    UserModel.isUsernameExist(value)
      .then(exist => {
        if (exist) {
          cb('Uživatelské jméno již v systému existuje!');
        } else {
          cb();
        }
      })
      .catch(() => {
        cb('Uzivatel jiz existuje cb!');
      });
  }

  handleValidateSecondPassword(rule, value, cb) {
    let password = this.props.form.getFieldValue('password');

    if (password === value) {
      cb()
    } else {
      cb('Hesla se neshodují!');
    }
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const fullFormItemLayout = {
      labelCol: {
        xs: { span: 0 },
        sm: { span: 0 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit.bind(this)}>
        <FormItem
          {...formItemLayout}
          label="Celé jméno" >
          {getFieldDecorator('name', {
            initialValue: this.props.initialValues && this.props.initialValues.name
              ? this.props.initialValues.name
              : null,
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        {!this.props.initialValues
          ?
          <FormItem
            {...formItemLayout}
            label="Uživatelské jméno" >
            {getFieldDecorator('username', {
              rules: [{
                type: 'string', message: 'Položka musí obsahovat text!',
              }, {
                required: true, message: 'Vyplňte prosím tuto položku!',
              }, {
                validator: this.handleValidateUsername
              }],
            })(
              <Input />
            )}
          </FormItem>
          : null
        }
        {!this.props.initialValues
          ?
          <FormItem
            {...formItemLayout}
            label="Heslo" >
            {getFieldDecorator('password', {
              rules: [{
                type: 'string', message: 'Položka musí obsahovat text!',
              }, {
                required: true, message: 'Vyplňte prosím tuto položku!',
              }],
            })(
              <Input type="password" />
            )}
          </FormItem>
          : null
        }
        {!this.props.initialValues
          ?
          <FormItem
            {...formItemLayout}
            label="Heslo ještě jednou" >
            {getFieldDecorator('secondpassword', {
              rules: [{
                type: 'string', message: 'Položka musí obsahovat text!',
              }, {
                required: true, message: 'Vyplňte prosím tuto položku!',
              }, {
                validator: this.handleValidateSecondPassword.bind(this)
              }],
            })(
              <Input type="password" />
            )}
          </FormItem>
          : null
        }
        <FormItem
          {...fullFormItemLayout}
          label="Role" >
          {getFieldDecorator('roles', {
            initialValue: this.props.initialValues && this.props.initialValues.roles
              ? this.props.initialValues.roles
              : null,
            rules: [{
              type: 'array', message: 'Položka musí obsahovat pole rolí!',
            }, {
              required: true, message: 'Vyberte prosím alespoň jednu roli!',
            }],
          })(
            <Transfer
              dataSource={this.state.transferKeysRoles}
              listStyle={{
                width: 460,
                height: 300,
              }}
              targetKeys={this.state.transferTargetKeysRoles}
              onChange={this.handleTransferChangeRoles.bind(this)}
              render={this.renderTransferItemRoles} />
          )}
        </FormItem>
        <FormItem
          {...fullFormItemLayout}
          label="Města" >
          {getFieldDecorator('cities', {
            initialValue: this.props.initialValues && this.props.initialValues.cities
              ? this.props.initialValues.cities
              : null,
            rules: [{
              type: 'array', message: 'Položka musí obsahovat pole měst!',
            }],
          })(
            <Transfer
              dataSource={this.state.transferKeysCities}
              listStyle={{
                width: 460,
                height: 300,
              }}
              targetKeys={this.state.transferTargetKeysCities}
              onChange={this.handleTransferChangeCities.bind(this)}
              render={this.renderTransferItemCities} />
          )}
        </FormItem>
        <FormItem
          {...fullFormItemLayout}
          label="Lokality" >
          {getFieldDecorator('locations', {
            initialValue: this.props.initialValues && this.props.initialValues.locations
              ? this.props.initialValues.locations
              : null,
            rules: [{
              type: 'array', message: 'Položka musí obsahovat pole lokalit!',
            }],
          })(
            <Transfer
              dataSource={this.state.transferKeysLocations}
              listStyle={{
                width: 460,
                height: 300,
              }}
              targetKeys={this.state.transferTargetKeysLocations}
              onChange={this.handleTransferChangeLocations.bind(this)}
              render={this.renderTransferItemLocations} />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          {this.props.initialValues
            ?
            <Button type="primary" htmlType="submit">Uložit</Button>
            : <Button type="primary" htmlType="submit">Vložit</Button>
          }
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={1024}
          title="Vytvoření nového uživatele"
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.form.resetFields();
            this.props.onModalCancel();
            this.setState({ modalVisible: false, transferTargetKeysRoles: [], transferTargetKeysCities: [], transferTargetKeysLocations: [] });
          }}
          footer={<p></p>} >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(UserForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/UserForm.js